export default ({ app, store }, inject) => {
  inject('initSberClickstream', function () {
    if (process.client) {
      const script = document.createElement('script')
      script.src =
        'https://static.ngcdn.ru/js-libs/sber-clickstream@0.9.1/index.umd.js'
      script.async = true

      script.onload = () => {
        window.clickstream.setConfig({
          reportUrl: app.$config.clickstreamReportUrl,
        })

        window.clickstream.setMeta({
          apiKey: app.$config.clickstreamApiKey,
        })

        window.clickstream.setProfile({
          appVersion: app.$config.clientVersion,
        })
      }

      script.onerror = function () {
        console.error('Failed to load the script.')
      }

      document.head.appendChild(script)
    }
  })
}
